import React, { forwardRef, Ref, useContext, useImperativeHandle, useState } from 'react';
import { getClasses } from '../../../utils/utils';
import TranslateService from '../../../services/translate-service';
import { eventStoreContext } from '../../../stores/events-store';
import { observer } from 'mobx-react';
import { formatDateString } from '../../../utils/defaults';
import { formatFromISODateString } from '../../../utils/time-utils';

interface DatePickerProps {
	modalValueName: string;
	ref?: any;

	wrapperClassName?: string;
	readOnly?: boolean;
	id?: string;
	name?: string;
	placeholder?: string;
	placeholderKey?: string;
	maxMenuHeight?: number;

	className?: string;
	onClick?: () => void;
	onKeyUp?: () => void;
	autoComplete?: string;

	enforceMinMax?: boolean;
}
export interface DatePickerRef {
	getValue(): string;
}
function DatePicker(props: DatePickerProps, ref: Ref<DatePickerRef> | any) {
	const eventStore = useContext(eventStoreContext);
	const {
		wrapperClassName,
		id,
		name,
		placeholder,
		placeholderKey,
		modalValueName,
		className,
		onClick,
		onKeyUp,
		enforceMinMax = false,
		autoComplete = 'true',
	} = props;
	const initialValue = eventStore.modalValues ? eventStore.modalValues[modalValueName] : undefined;
	let [value, setValue] = useState(initialValue);

	// make our ref know our functions, so we can use them outside.
	useImperativeHandle(ref, () => ({
		getValue: () => {
			return value;
		},
	}));

	const content = props.readOnly ? (
		value ? (
			formatFromISODateString(value)
		) : (
			'-'
		)
	) : (
		<input
			id={id}
			name={name}
			className={getClasses(['datePickerInput'], className)}
			ref={ref}
			type="datetime-local"
			onKeyDown={(e) => {
				e.preventDefault();
				return false;
			}}
			value={value}
			onClick={() => {
				onClick && onClick();
			}}
			onKeyUp={() => {
				onKeyUp && onKeyUp();
			}}
			onChange={(e) => {
				setValue(e.target.value);
				eventStore.modalValues[modalValueName] = e.target.value;
			}}
			// causing problems in mobile:
			// placeholder={
			// 	placeholder
			// 		? placeholder
			// 		: placeholderKey
			// 		? TranslateService.translate(eventStore, placeholderKey)
			// 		: undefined
			// }
			autoComplete={autoComplete}
			min={enforceMinMax ? `${eventStore.customDateRange.start}T00:00` : undefined}
			max={enforceMinMax ? `${eventStore.customDateRange.end}T23:59` : undefined}
			data-value={!eventStore.isMobile ? 'disabled' : value ?? 'empty'}
			readOnly={props.readOnly}
		/>
	);

	return <div className={getClasses('triplan-date-picker-input', wrapperClassName)}>{content}</div>;
}

export default observer(forwardRef<DatePickerRef, DatePickerProps>(DatePicker));
